<template>

    <v-snackbar :value="show"
                :timeout="timeout"
                :color="color"
                elevation="24"
                centered
                app
                multi-line
    >
        {{msg}}
        <template v-slot:action="{ attrs }">
            <v-btn
                    color="white"
                    text
                    v-bind="attrs"
                    @click="close"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </template>
    </v-snackbar>

</template>

<script>
    import {mapMutations, mapActions, mapGetters} from 'vuex'

    export default {
        name: "flash",
        props: {
            msg: {
                type: String,
                default: ''
            },
            timeout: {
                type: Number,
                default: 1000
            },
            color: {
                type: String,
                default: 'deep-purple accent-4'
            }
        },
        data() {
            return {
                show: false
            }
        },
        methods: {
            ...mapMutations([
                'setFlash',
            ]),
            close() {
                this.show = false;
                this.setFlash('');
            }
        },
        watch: {
            msg(a) {
                this.show = a !== '';
            }
        }
    }
</script>

<style scoped>

</style>